import { render, staticRenderFns } from "./SLDViewPage.vue?vue&type=template&id=40e2a971&scoped=true"
import script from "./SLDViewPage.vue?vue&type=script&lang=js"
export * from "./SLDViewPage.vue?vue&type=script&lang=js"
import style0 from "./SLDViewPage.vue?vue&type=style&index=0&id=40e2a971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e2a971",
  null
  
)

export default component.exports